import get from 'lodash/get';
import buildCJAPageViewPayload from 'yoda-core-components/lib/helpers/Analytics/CJAPageViewBuilder';
import { buildCJALinkClick } from 'yoda-site-components/lib/analytics/CJAEventsHelper';

const legacyVersion = 'apollo 1 2017 redesign yoda account';

const legacyPages = [
    'sign in',
    'create account',
    'my account',
    'reset password',
    'sign out',
    'session timeout',
    'full access timeout',
];

const getPageFields = (pageName) => {
    const name = (pageName || '').toLowerCase();
    return {
        name,
        type: 'account',
        siteSection: 'account',
        category: { primary: 'account' },
        tech: {
            version: legacyPages.includes(name)
                ? legacyVersion
                : `apollo 1 ${new Date().getFullYear()} yoda account`,
        },
    };
};

const getUserOverrides = (state) => {
    const overrides = {};

    // PII fields — not exposed to adobeDataLayer
    // const profile = get(state, 'accountDetails.profile', {});
    // if (profile.firstName) overrides.firstName = profile.firstName;
    // if (profile.lastName) overrides.lastName = profile.lastName;
    // if (profile.emailAddress) overrides.email = profile.emailAddress;
    // if (profile.phoneNumber) overrides.phoneNumber = profile.phoneNumber;

    const defaultAddress = get(state, 'addressDetails.defaultAddress', {});
    // if (defaultAddress.addressLineOne) overrides.address = defaultAddress.addressLineOne;
    if (defaultAddress.state) overrides.state = defaultAddress.state;
    if (defaultAddress.zip) overrides.zip = defaultAddress.zip;

    return overrides;
};

const trackCJAPageView = (store, pageName) => {
    const state = store.getState();
    const pageData = getPageFields(pageName);
    const userOverrides = getUserOverrides(state);
    const extraData = { interactionName: 'regular_pageview' };
    const payload = buildCJAPageViewPayload(pageData, userOverrides, extraData);
    return { eventName: 'pageView', eventData: payload };
};

const trackCJANotificationOptins = (preferences = []) => {
    const { optinType, optinFlag, notificationType, source } = preferences[0] || {};
    const { eventName, payload } = buildCJALinkClick({
        linkModuleName: `updatenotification:preferences:optintype:${optinType}:optinflag:${optinFlag}:notificationtype:${notificationType}:source:${source}`,
    });
    return { eventName, eventData: payload };
};

export { trackCJAPageView, trackCJANotificationOptins };
